import { BackendResponse } from "../BackendResponse";
import { withNextApi } from "../nextApiHelpers";

export const deleteProfilePicture =
  withNextApi<BackendResponse>(
    "/cvp/CvpDeletePicture",
    {
      method: "GET",
    }
  );
